import {useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import FilledTextButton from "../components/buttons/FilledTextButton";

export default function NotFoundScreen() {
  const theme = useTheme();
  const style = styles(theme);
  const navigate = useNavigate();

  return (
    <section style={style.mainContainer}>
      <Typography variant="h6" fontWeight={'500'} color={theme.text.primary}>
        Pareces haberte perdido. Nos pasa a todos en algún momento.
      </Typography>
      <FilledTextButton label="Volver" onClick={() => navigate('/')}/>
    </section>
  );
}

const styles = (theme) => ({
  mainContainer: {
    backgroundColor: theme.colors.background,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    gap: 16,
  },
  image: {
    width: '900px'
  },
})